import { render, staticRenderFns } from "./DeveloperNotes.vue?vue&type=template&id=5c5fe728&scoped=true"
import script from "./DeveloperNotes.vue?vue&type=script&lang=js"
export * from "./DeveloperNotes.vue?vue&type=script&lang=js"
import style0 from "./DeveloperNotes.vue?vue&type=style&index=0&id=5c5fe728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5fe728",
  null
  
)

export default component.exports